
<template>
  <!-- 咨询分页导航 -->
  <div>
    <v-header />
    <div class="sub-about" style="overflow:hidden">
      <ul class="naviagation">
        <li @click="news" :class="navID=== 1 ? 'active':''"><span>简介</span></li>
        <li @click="corp" :class="navID=== 2 ? 'active':''"><span>历程</span></li>
        <li @click="act" :class="navID=== 3 ? 'active':''"><span>荣誉</span></li>
        <li @click="experience" :class="navID=== 4 ? 'active':''"><span>校区</span></li>
      </ul>
      <!-- <div class="line"></div> -->
      <Introduction :navID="navID" />
      <Road :navID="navID" />
      <Honor :navID="navID" />
      <Camp :navID="navID" />
    </div>
  </div>
</template>

<script>
import VHeader from "../header/VHeader";
import Introduction from "./Introduction";
import Road from "./Road";
import Honor from "./Honor";
import Camp from "./Camp";
export default {
  metaInfo: {
  title: '关于我们_51Testing软件测试培训网',
  meta: [{
      name: 'keywords',
      content: '51Testing,软件测试,软件测试培训,博为峰',
    },{
      name: 'description',
      content: '51Testing软件测试培训网,专业的软件测试培训中心,十多年来专注为客户提供软件测试就业培训,周末培训,企业内训,ISTQB认证培训等服务,在上海,北京,深圳,成都,南京,武汉,西安,杭州,重庆,广州等地设有分支机构.',
    }]
  },
  data() {
    return {
      navID: ''
    };
  },
  components: {
    VHeader,
    Introduction,
    Road,
    Honor,
    Camp
  },
  watch:{
    '$route':{
      handler(){
        this.navID = Number(this.$route.query.id) || 1
      }
    }
  },
  beforeMount() {
    this.navID = Number(this.$route.query.id) || 1
  },
  mounted() {
    sessionStorage.clear();
  },
  methods: {
    news() {
      this.navID = 1;
      this.$router.replace(`/about.html`)
    },
    corp() {
      this.navID = 2;
      this.$router.replace(`/about.html?id=2`)
    },
    act() {
      this.navID = 3;
      this.$router.replace(`/about.html?id=3`)
    },

    experience() {
      this.navID = 4;
      this.$router.replace(`/about.html?id=4`)
    }
  }
};
</script>

<style>
.sub-about .naviagation {
  /* padding-left: 30px; */
  margin-top: 8px;
  margin-bottom: 0px;
  overflow: hidden;
  background: #ffffff;
  line-height: 54px;
  letter-spacing: 2px;
  padding: 12.7px 30px;
}
.sub-about .naviagation li {
  float: left;
  font-size: 28px;
  color: #282828;
  width: 25%;
  text-align: center;
  height: 54px;
  position: relative;
  z-index: 0;
  /* font-weight: bold; */
}
.sub-about .naviagation li span{
  position: relative;
  z-index: 1;
}
.sub-about li.active {
  color: #ffffff;
}
.sub-about .active::after{
  content: ' ';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top:0;
  border-radius: 27px;
  background: #0084ff;
}
/* .sub-info .click {
  margin-left: 128px;
} */
.naviagate .line {
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue